module.exports = __webpack_public_path__ + "static/media/exercicio.9b95e407.png";